import React, { Component } from 'react';
import './ModalDatosContacto.css';
import ButtonBase from '../button/ButtonBase';
import Input from '../input/Input'
import i18n from '../../../config/I18n'
import IconoEditar from './assets/svg/icnBtnEditar.svg'
import IconoConfirmarDatos from './assets/svg/icnBtnConfirmarDatos.svg'
import IconoConfirmado from './assets/svg/icnBtnConfirmado.svg'
import IconoGuardarConfirmar from './assets/svg/icnBtnGuardarYConfirmar.svg'
import IcnCerrarModalfrom from './assets/svg/icnCerrarModal.svg'

class ModalDatosContacto extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = ({
      activaEdicion: false,
      validaDatos: false
    });
  }

  componentDidMount = () => {
    const { telefono, email } = this.props;
    if (telefono === "" || email === "") {
      this.setState({ activaEdicion: true });
    }
  }

  mostrarEdicionDatosContacto = () => {
    const { activaEdicion } = this.state;
    this.setState({ activaEdicion: !activaEdicion });
  }

  validaConfirmaDatos = () => {
    const { validaDatos, activaEdicion } = this.state;
    if (!validaDatos) { this.setState({ validaDatos: !validaDatos }); }

    if (activaEdicion) { this.mostrarEdicionDatosContacto(); }

  }

  render() {
    const { telefono, email, funcion, isOpen, solicitar, handleChange, emailValido, telefonoValido } = this.props;
    const { activaEdicion, validaDatos } = this.state;
    if (!isOpen) return null;
    return (
      <div className="Modal ModalDatosContacto">
        <div className="Modal__container">
          <div className="modal">
            <div className="container">
              <div className="row">
                <div className="col">
                  <h2 className="titleModal"><strong>{i18n.t('modalDatosContacto.titulo')}</strong></h2>
                  <ButtonBase
                    icons={IcnCerrarModalfrom}
                    callClick={funcion}
                    css="salir"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p>{i18n.t('modalDatosContacto.subtitulo')}</p>
                  <br />
                </div>
                <div className={activaEdicion ? "col-sm-12 col-md-6 col-lg-6" : "col-sm-12 col-md-4 col-lg-4"}>
                  <div className="row">
                    <div className="col">
                      <p className="small">{activaEdicion ? (<strong>{i18n.t('modalDatosContacto.telefonoCelular')}</strong>) : i18n.t('modalDatosContacto.telefono')}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      {activaEdicion ? <Input valor={telefono} funcionOnChange={handleChange} nombreInput='telefono' /> :
                        (<h3><strong>{telefono}</strong></h3>)
                      }
                    </div>
                  </div>
                </div>
                <div className={activaEdicion ? "col-sm-12 col-md-6 col-lg-6" : "col-sm-12 col-md-8 col-lg-8"}>
                  <div className="row">
                    <div className="col">
                      <p className="small">{activaEdicion ? (<strong>{i18n.t('modalDatosContacto.correoElectronicoAst')}</strong>) : i18n.t('modalDatosContacto.correoElectronico')}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      {activaEdicion ? <Input valor={email} funcionOnChange={handleChange} nombreInput='email' /> :
                        (<h3><strong>{email}</strong></h3>)
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div className="container pbottom0">
              <div className="row">
                { /* guardar y confirmar */
                  activaEdicion && (
                    <div className="col-sm-12 col-md-4 col-lg-4 no-gutters mbottom15">
                      <ButtonBase
                        etiqueta={i18n.t('modalDatosContacto.guardarConfirmar')}
                        css='blue'
                        callClick={this.validaConfirmaDatos}
                        enabled={email !== '' && telefono !== '' && emailValido && telefonoValido}
                        icons={IconoGuardarConfirmar}
                      />
                    </div>
                  )
                }
                {activaEdicion ? (
                  <div className="col-sm-12 col-md-5 col-lg-5 mbottom15 order-lg-first order-md-first">
                    <div className="nota">
                      <div className="triangleRight"><div /></div>
                      <div className="left">
                        {i18n.t('modalDatosContacto.notaUnica')}
                      </div>
                    </div>
                  </div>
                ) : (
                  /* EDITAR  end */
                  <>
                    <div className={validaDatos ? "col-3" : "col-1"} />
                    <div className="col-sm-12 col-md-3 col-lg-3 no-gutters mbottom15">
                      <ButtonBase
                        etiqueta={i18n.t('modalDatosContacto.editar')}
                        css='blueline'
                        callClick={this.mostrarEdicionDatosContacto}
                        icons={IconoEditar}
                      />
                    </div>
                  </>
                )}
                { /* confirmar */
                  !validaDatos && !activaEdicion && (
                    <div className="col-sm-12 col-md-5 col-lg-5 no-gutters mbottom15">
                      <ButtonBase
                        etiqueta={i18n.t('modalDatosContacto.confirmarDatos')}
                        css='blue'
                        callClick={this.validaConfirmaDatos}
                        enabled={email !== '' && telefono !== '' && emailValido && telefonoValido}
                        icons={IconoConfirmarDatos}
                      />
                    </div>
                  )}
                { /* confirmado */
                  validaDatos && !activaEdicion && (
                    <div className="col-sm-12 col-md-3 col-lg-3 no-gutters mbottom15">
                      <ButtonBase
                        etiqueta={i18n.t('modalDatosContacto.confirmado')}
                        css='blue'
                        icons={IconoConfirmado}
                      />
                    </div>
                  )}
                <div className="col-sm-12 col-md-3 col-lg-3 no-gutters mbottom15">
                  <ButtonBase
                    etiqueta={i18n.t('modalDatosContacto.enviarSolicitud')}
                    css='red'
                    callClick={solicitar}
                    enabled={validaDatos ? !activaEdicion : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ModalDatosContacto;